const config = {
  API_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '',
  MY_LIBRARY_MAX_FILE_SIZE: 12582912, // 12mb // 12 * 1024 * 1024
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN ? process.env.REACT_APP_SENTRY_DSN : '',
  LOG_ROCKET: process.env.REACT_APP_LOG_ROCKET ? process.env.REACT_APP_LOG_ROCKET : '',
}

export default config
